import alert from '@/plugins/alert'
import { AssetInventoryAudit } from '@/plugins/api'
import { rangeRight } from 'lodash'

export default {
  namespaced: true,
  state: {
    loading: false,
    auditData: {},
    count: 0,
    pageText: '',
    itemsPerPage: 10,
    auditSearchParams: {},
    totalItems: 0,
    audits: []
  },
  actions: {
    async searchAuditList({ commit, state, dispatch }, query) {
      const auditSearchParams = {
        isDelete: false,
        _limit: state.itemsPerPage,
        ...query
      }
      commit('changeState', { auditSearchParams })
      dispatch('requestPageSettings', {})
    },

    async requestPageSettings({ state, commit, dispatch }, { page, itemsPerPage } = {}) {
      commit('changeState', { loading: true })
      if (!page) page = 1
      if (!itemsPerPage) itemsPerPage = state.itemsPerPage

      if (state.auditSearchParams) {
        const auditSearchParams = {
          ...state.auditSearchParams,
          isDelete: false,
          _start: (page - 1) * itemsPerPage,
          _limit: itemsPerPage,
          _sort: 'createdAt:DESC'
        }

        const [totalItems, audits] = await Promise.all([
          AssetInventoryAudit.count(auditSearchParams),
          AssetInventoryAudit.search(auditSearchParams)
        ])

        if (totalItems > (page - 1) * itemsPerPage || page === 1) {
          commit('changeState', {
            audits,
            totalItems,
            itemsPerPage,
            auditSearchParams
          })
          const pageStart = (page - 1) * itemsPerPage + 1
          let pageStop = page * itemsPerPage
          pageStop = pageStop > totalItems || pageStop === -1 ? totalItems : pageStop
          const pageText = `${pageStart}-${pageStop} trên ${totalItems}`
          commit('setPageText', pageText)
        } else {
          const pages = rangeRight(1, page)
          for (let index = 0; index < pages.length; index++) {
            const selectedPage = pages[index]
            if (totalItems > (selectedPage - 1) * itemsPerPage) {
              dispatch('requestPageSettings', {})
              break
            }
          }
        }
      }
      commit('changeState', { loading: false })
    },

    async createAudit({ commit, state }, auditData) {
      try {
        const created = await AssetInventoryAudit.create(auditData)
        commit('changeState', {
          audits: [created, ...state.audits]
        })
        alert.success('Tạo đợt kiểm kê thành công')
        return created
      } catch (e) {
        alert.error(e)
      }
    },

    async updateAudit({ commit }, { id, ...auditData }) {
      try {
        const updated = await AssetInventoryAudit.update(id, auditData)
        commit('updateAudit', updated)
        alert.success('Cập nhật đợt kiểm kê thành công')
        return updated
      } catch (e) {
        alert.error(e)
      }
    },

    async removeAudit({ commit }, id) {
      try {
        await AssetInventoryAudit.remove(id)
        commit('removeAudit', id)
      } catch (e) {
        alert.error(e)
      }
    }
  },
  mutations: {
    setPageText(state, pageText) {
      state.pageText = pageText
    },
    updateAudit(state, auditData) {
      state.audits = state.audits.map(a => (auditData.id === a.id ? auditData : a))
    },
    removeAudit(state, id) {
      state.audits = state.audits.filter(a => a.id !== id)
    },
    changeState(state, payload) {
      Object.assign(state, payload)
    }
  }
}
